module.exports = __webpack_public_path__ + "static/footer-img-2-4475a2047c7d8c05a3c6938844e113c3.png";